<!--mat-slide-toggle class="m-1" *ngIf="selectedGroupsDto !== null && !isCXOne"
    [checked]="selectedGroupsDto?.toggleGroupData"
    [(ngModel)]="selectedGroupsDto.toggleGroupData"
    (click)="selectedGroupsDto.toggleGroupData = !selectedGroupsDto.toggleGroupData; toggleGroups();"
    [disabled]="isLoadingGroups">
    <mat-label class="font-size-12" cvLocalizedText langSection="Group_Selector" langKey="Data_Toggle">Show groups only with data on the selected date range</mat-label>
</mat-slide-toggle-->
<div class="group-selector-container" [ngClass]="direction === 'vertical' ? 'pr-3' : 'row'">
    <div class="d-flex" *ngFor="let groupType of groupTypes" [class.col]="direction === 'horizontal'" [class.mb-2]="direction === 'vertical'">
        <button type="button" [ngClass]="showSelectedToggle ? 'd-flex' : 'd-none'"
            id="{{pageName + '-groupSelector-ViewBy-' + groupType.name + baseGroupType | cleanId}}"
            class="btn btn-text mt-auto mr-4 body-2 flex-shrink-0 lato-bold" 
            (click)="selectLevel(groupType.level)"
            [title]="getLocalizationString('Group_Selector_Tooltip','The table will display data about the level chosen.')"
            style="white-space: nowrap"
            [disabled]="isLoadingGroups"
        >
            <div class="rounded border color-cerulean mt-1 mr-2" [class.bg-cerulean]="hasSelectedToggle && selectedLevel === groupType.level" style="height: 0.5rem; width: 0.5rem; border-color: currentColor"></div>
            <div cvLocalizedText langSection="AZ_Modules" langKey="View_By">View by</div>
        </button>
        <div class="group-selector-body flex-fill d-flex flex-column" [class.mx-3]="!showSelectedToggle && direction === 'vertical'" [style.max-width]="direction === 'vertical' ? (showSelectedToggle ? '228px' : '280px') : undefined">
            <label *ngIf="showLabels" class="body-2 color-whaleTail" [class.mb-1]="direction === 'vertical'">{{ getLocalizationString(groupType.name, groupType.name) }}</label>
            <cv-multi-select *ngIf="hasMultiSelect && maxSelectionLimit(groupType.level) > 0"
                [id]="(pageName + 'groupSelector-Select-' + groupType.name + baseGroupType) | cleanId"
                [autoWidth]="direction === 'horizontal'"
                [isLoading]="isLoadingGroups && (lastLevelChanged === 0 || lastLevelChanged > groupType.level)"
                [disabled]="hasSelectedToggle && selectedLevel > groupType.level"
                [placeholder]="'Select ' + groupType.name + '(s)'"
                [selectionText]="selectedGroupsText[groupType.level]"
                [options]="groupsByLevel[groupType.level].Groups"
                [value]="selectedGroups[groupType.level]"
                email="Email"
                [team]="teamMap"
                [groupNameExist]="agentGroup"
                (selectionChanged)="onMultiSelectValueChanged(groupType.level, $event)"
                primaryKey="GroupID" label="GroupName"
                (opened)="onGroupSelectorOpen(groupType.level)"
                (closed)="onGroupSelectorClose(groupType.level)"
                [showSelectedToggle]="showSelectedToggle"
                [maxSelectionLimit]="maxSelectionLimitValue ? maxSelectionLimitValue : maxSelectionLimit(groupType.level)"
                [isInfiniteDropdown]="isInfiniteDropdown"
            ></cv-multi-select>
            <cv-multi-select *ngIf="hasMultiSelect && maxSelectionLimit(groupType.level) <= 0"
                [id]="(pageName + 'groupSelector-Select-' + groupType.name + baseGroupType) | cleanId"
                [autoWidth]="direction === 'horizontal'"
                [isLoading]="isLoadingGroups && (lastLevelChanged === 0 || lastLevelChanged > groupType.level)"
                [disabled]="hasSelectedToggle && selectedLevel > groupType.level"
                [placeholder]="'Select ' + groupType.name + '(s)'"
                [selectionText]="selectedGroupsText[groupType.level]"
                [options]="groupsByLevel[groupType.level].Groups"
                [value]="selectedGroups[groupType.level]"
                email="Email"
                [team]="teamMap"
                [groupNameExist]="agentGroup"
                (selectionChanged)="onMultiSelectValueChanged(groupType.level, $event)"
                primaryKey="GroupID" label="GroupName"
                (opened)="onGroupSelectorOpen(groupType.level)"
                (closed)="onGroupSelectorClose(groupType.level)"
                [showSelectedToggle]="showSelectedToggle"
                [maxSelectionLimit]="maxSelectionLimitValue"
                [isInfiniteDropdown]="isInfiniteDropdown"
            ></cv-multi-select>
            <cv-single-select *ngIf="!hasMultiSelect"
                [id]="(pageName + 'groupSelector-Select-' + groupType.name + baseGroupType) | cleanId"
                [autoWidth]="direction === 'horizontal'"
                [isLoading]="isLoadingGroups && (lastLevelChanged === 0 || lastLevelChanged > groupType.level)"
                [disabled]="hasSelectedToggle && selectedLevel > groupType.level"
                [placeholder]="selectLocalized + ' ' + groupType.name.toLowerCase()"
                [selectionText]="selectedGroupsText[groupType.level]"
                [options]="groupsByLevel[groupType.level].Groups"
                [value]="groupType.level === 1 && hideAllWhenSingleSelect && selectedGroup[groupType.level] < 1 ? -1 : selectedGroup[groupType.level]"
                (valueChange)="onSingleSelectValueChanged(groupType.level, $event)"
                primaryKey="GroupID" label="GroupName"
                (opened)="onGroupSelectorOpen(groupType.level)"
                (closed)="onGroupSelectorClose(groupType.level)"
            ></cv-single-select>
        </div>
    </div>
</div>
